// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-main-wrapper {
  /* margin-top: 46px; */
  margin-top: 21px;
}

.profile-heading-wrap {
  display: flex;
  align-items: center;
  gap: 20px;
}

.profile-heading-wrap img {
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.profile-heading-wrap img:hover{
  scale: 0.9;
}

.profile-readonly-info-wrap {
  margin-top: 40px;
}

.profile-readonly-info-repeat {
  margin-bottom: 35px;
}

.profile-readonly-info-repeat p {
  font-size: 12px;
  color: #626262;
  font-weight: 400;
  margin: 0px;
  opacity: 0.5;
  padding-bottom: 14px;
}

.profile-readonly-info-repeat span {
  font-size: 14px;
  color: #1a1919;
  font-weight: 500;
  margin: 0px;
}

.profile-detail-main-wrapper {
  display: flex;
  align-items: center;
  gap: 20px;
}

.pofile-detail-main-wrap h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 0px;
  padding-bottom: 2px;
}

.pofile-detail-main-wrap p {
  font-size: 14px;
  color: #1A1919;
  font-weight: 500;
  margin: 0px;
}

.profile-main-wrap {
  display: grid;
  grid-template-columns: 100%;
  gap: 25px;
  align-items: center;
}

.profile-left-wrap h2 {
  font-size: 38px;
  color: #14172e;
  font-weight: bold;
  margin: 0px;
}

.profile-picture-wrap {
  position: relative;
  margin-top: -58px;
  width: 150px;
}

.profile-page-main-image {
  width: 100%;
}

.profile-page-main-image img {
  width: 100%;
  /* height: 210px; */
  border-radius: 17px;
    height: 192px;
  object-fit: fill;
}

.profile-picture-wrap img {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  object-fit: cover;
}

.profile-edit-icon img {
  position: absolute;
  bottom: 28px;
  right: 0px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  object-fit: cover;
}

.upload-profileImage-gif {
  position: absolute;
  bottom: 28px;
  right: 0px;
  width: 40px;
  height: 40px;
  background: #00a19b;
  border-radius: 50%;
}

.profile-info-main-wrapper {
  /* display: flex;
  justify-content: space-between;
  gap: 50px; */
  /* width: 100%; */
  display: grid;
  grid-template-columns: calc(74% - 18px) calc(26% - 18px); /* Adjust for half the gap on each column */
  gap: 36px;
}

.profile-basic-info-wrap {
  position: relative;
  margin-top: 16px;
  width: 100%;
  /* height: 406px; */
  height: 416px;
  border: 2px solid #f8f8f8;
  /* border: 2px solid #cac8c994; */
  padding: 0px 54px;
  /* padding-top: 56px; */
  padding-top: 32px;
  border-radius: 34px;
}

.profile-detail-icon img {
  width: 70px;
  height: 70px;
  position: absolute;
  top: 20px;
  right: 20px;
  object-fit: cover;
}

.profile-basic-info-wrap h4 {
  font-size: 18px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
  /* margin-bottom: 40px; */
}

.profile-info-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  /* margin-bottom: 40px; */
  margin-bottom: 24px;
}

.profile-left-inner-wrapper{
  display: flex;
  justify-content: space-between;
  gap: 70px;
  padding: 0px 34px
}

.profile-left-inner-wrapper .profile-inner-basic-info{
  width: 50%;
}

.profile-left-inner-wrapper .change-password-info-wrap{
  width: 50%;
}

.profile-info-header-wrapper button{
  width: 114px;
  height: 49px;
}

.profile-info-heading-wrap{
  display: flex;
  align-items: center;
  gap: 10px;
}

.profile-info-heading-wrap img{
  width: 40px;
  height: 40px;
}

.profile-right-image-wrap {
  width: 88%;
  margin: 0 auto;
}

.profile-right-image-wrap img {
  width: 100%;
  object-fit: cover;
  border-radius: 18px;
}

.change-input-wrap img {
  width: 22px;
  height: 22px;
  position: absolute;
  top: 0px;
  cursor: pointer;
}

.twofa-enable-main-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #f3f3f3;
  border-radius: 9px;
  padding: 0px 18px;
  height: 62px;
}

.twofa-enable-left-wrap p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 500;
  margin: 0px;
}

.profile-changes-button {
  /* width: 30%; */
    width: 42%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.profile-changes-button button {
  width: 219px;
  height: 49px;
  font-size: 14px;
}

.twofa-desable-req-main-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #f3f3f3;
  background: #f3f3f3;
  border-radius: 9px;
  padding: 0px 18px;
  height: 62px;
}

.twofa-desable-req-main-wrap img {
  width: 34px;
}

p.resend-email-text {
  font-size: 12px;
  color: #00a19b;
  font-weight: 500;
  margin: 0px;
  padding-top: 8px;
  cursor: pointer;
}

span.error-msg.profile-error-msg {
  position: absolute;
  bottom: -16px;
  white-space: nowrap;
}

.profile-guideline-info-wrap img{
  width: 16px;
  height: 16px;
  position: absolute;
  left: 9px;
  top: 110px;
  cursor: pointer;
}

.profile-left-inner-wrapper .field {
  margin-bottom: 36px;
}

.profile-info-heading-wrap img.info-icon{
  width: unset;
  height: unset;
  position: absolute;
  right: -10px;
  top: -2px;
  cursor: pointer;
}

.profile-readonly-info-wrap1{
  margin-top: 32px;
}

.profile-twofa-security-img-wrap{
  position: relative;
}

.phone-number-input-box {
  display: flex;
  gap: 10px;
}

.number-flag-box-wrap {
  width: 74px;
  height: 62px;
  border: 1px solid;
  border: 1px solid #f3f3f3;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.number-flag-box-wrap img{
  width: 22px;
}

.number-flag-box-wrap p{
  font-size: 14px;
  font-weight: 500;
  color: #1A1919;
  margin: 0px;
}

.phone-number-input-box{
  position: relative;
}


/******* Resposive css ****/
@media (max-width: 1024px) {
  .profile-main-wrap {
    display: grid;
    grid-template-columns: 100%;
    gap: 0;
  }

  .profile-info-main-wrapper {
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding-bottom: 40px;
  }

  .profile-right-wrap {
    display: none;
  }

  .profile-left-wrap h2 {
    font-size: 22px;
    font-weight: 600;
  }

  .profile-picture-wrap img {
    width: 120px;
    height: 120px;
  }


  .profile-guideline-info-wrap img{
    width: 16px;
    height: 16px;
  }

  
  .profile-picture-wrap {
    width: 120px;
}

  .profile-edit-icon img {
    width: 34px;
    height: 34px;
    bottom: 25px;
    right: 0px;
  }

  .profile-guideline-info-wrap img {
    left: 9px;
    top: 100px;
  }

  .upload-profileImage-gif {
    bottom: 30px;
    right: 0px;
    width: 42px;
    height: 42px;
  }

  .profile-basic-info-wrap {
    margin-top: 0px;
    height: auto;
    padding: 43px 18px;
    padding-bottom: 23px;
  }

  .profile-basic-info-wrap h4 {
    font-size: 18px;
    margin-bottom: 0px;
    font-weight: 500;
  }

  .profile-input-field {
    margin-bottom: 30px;
  }

  .profile-main-wrapper {
    padding-bottom: 100px;
  }

  .profile-readonly-info-repeat p {
    padding-bottom: 10px;
  }

  .login-button.profile-changes-button {
    position: fixed;
    width: 100%;
    padding-right: 40px !important;
    padding-left: 0px !important;
    background-color: #fff;
    z-index: 99;
    bottom: 90px;
  }

  .profile-picture-main-wrap {
    width: 50%;
    margin: unset;
  }

  .change-password-info-wrap {
    margin-top: 10px;
  }

  .profile-changes-button {
    width: 100%;
  }

  .profile-readonly-info-wrap {
    margin-top: 0px;
  }

  .profile-page-main-image img {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 10px;
  }


  .profile-detail-main-wrapper {
    gap: 10px;
  }

  .profile-info-header-wrapper {
    margin-bottom: 34px;
  }

  .profile-readonly-info-repeat {
    margin-top: 35px;
    margin-bottom: 20px;
  }

  .profile-detail-icon img {
    width: 55px;
    height: 55px;
  }

  .twofa-enable-main-wrapper {
    margin-bottom: 20px;
  }

  .profile-left-inner-wrapper {
    display: block;
    padding: 0px 0px;
  }

  .profile-left-inner-wrapper .profile-inner-basic-info {
    width: 100%;
  }

  .profile-left-inner-wrapper .change-password-info-wrap {
    width: 100%;
  }

  .profile-left-inner-wrapper .field {
    margin-bottom: 20px;
  }

  .profile-changes-button button {
    width: 100%;
    height: 49px;
  }

  .profile-info-heading-wrap img{
    width: 35px;
    height: 35px;
  }
}

@media (max-width: 450px) {
.pofile-detail-main-wrap p {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
}

@media (max-width: 360px) {
  .pofile-detail-main-wrap h3 {
    font-size: 16px;
  }

  .pofile-detail-main-wrap p {
    font-size: 12px;
    width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
}

@media (min-width: 768px) and (max-width: 1024px) {
  .login-button.profile-changes-button {
    position: fixed;
    width: 100%;
    padding-right: 20px !important;
  }

  .profile-info-heading-wrap img{
  width: 34px;
  height: 34px;
}
}

@media (min-width: 1025px) and (max-width: 1599px) {
  span.error-msg.profile-error-msg {
    position: absolute;
    bottom: -6px;
    white-space: nowrap;
  }

  .profile-left-wrap h2 {
    font-size: 22px;
  }

  .profile-picture-wrap {
    position: relative;
    margin-top: -54px;
    width: 120px;
  }

  .profile-guideline-info-wrap img {
    left: -1px;
    top: 80px;
  }

  .profile-picture-wrap img {
    width: 108px;
    height: 108px;
  }

  .profile-guideline-info-wrap img{
    width: 16px;
    height: 16px;
  }

  .profile-page-main-image img {
    width: 100%;
    height: 130px;
    object-fit: fill;
  }

  .profile-guideline-info-wrap img{
    width: 16px;
    height: 16px;
  }

  .profile-edit-icon img {
    width: 30px;
    height: 30px;
    bottom: 30px;
    right: 6px;
  }

  .upload-profileImage-gif {
    width: 32px;
    height: 32px;
    bottom: 40px;
    right: 60px;
  }

  .profile-heading-wrap {
    gap: 12px;
  }

  .profile-heading-wrap img {
    width: 21px;
    height: 21px;
  }

  .profile-basic-info-wrap {
    margin-top: 0px;
    height: 282px;
    border-radius: 24px;
    padding: 0px 30px
  }

  .profile-readonly-info-wrap {
    margin-top: 10px;
  }

  .profile-detail-icon img {
    width: 52px;
    height: 52px;
    top: 10px;
    right: 10px;
  }

  .profile-info-header-wrapper {
    margin-bottom: 14px;
    margin-top: 14px;
  }

  .profile-readonly-info-wrap .profile-info-header-wrapper {
    margin-bottom: 34px;
  }

  .twofa-enable-main-wrap {
    height: 48px;
  }

  .profile-basic-info-wrap h4 {
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
  }

  .profile-readonly-info-repeat p {
    padding-bottom: 8px;
  }

  .profile-readonly-info-repeat {
    margin-bottom: 36px;
  }

  .profile-readonly-info-repeat span {
    font-size: 12px;
    font-weight: 500;
  }

  .profile-main-wrap {
    grid-template-columns: 100%;
    gap: 20px;
    padding-bottom: 20px;
  }

  .twofa-enable-left-wrap p {
    font-size: 12px;
  }

  p.disable-req-text {
    font-weight: 400;
  }

  .twofa-desable-req-main-wrap img {
    width: 26px;
  }

  .profile-right-image-wrap {
    width: 400px;
    height: 535px;
    margin: 0 auto;
  }

  .profile-right-image-wrap img {
    width: 100%;
    height: 535px;
    object-fit: cover;
  }

  .profile-basic-info-wrap button {
    height: 48px;
  }

  .profile-info-main-wrapper {
    grid-template-columns: calc(74% - 9px) calc(26% - 9px); /* Adjust for half the gap on each column */
    gap: 18px;
  }



  .profile-picture-main-wrap {
    margin-top: 12px;
  }

  .profile-main-wrapper {
    margin-top: 20px;
  }

  p.resend-email-text {
    padding-top: 7px;
  }

  .twofa-desable-req-main-wrap {
    height: 48px;
  }

  .twofa-confirm-modal-content-wrap p {
    width: 90%;
  }

  .profile-left-inner-wrapper .field {
    margin-bottom: 18px;
  }

  .pofile-detail-main-wrap h3 {
    font-size: 16px;
  }

  .pofile-detail-main-wrap p {
    font-size: 12px;
    color: #1A1919;
    font-weight: 500;
  }

  .profile-detail-main-wrapper {
    gap: 10px;
  }

  .profile-left-inner-wrapper {
    gap: 50px
  }

  .number-flag-box-wrap {
    width: 74px;
    height: 48px;
  }

  .number-flag-box-wrap img {
    width: 20px;
  }

  .number-flag-box-wrap p {
    font-size: 12px;
  }

  .profile-info-heading-wrap img{
  width: 32px;
  height: 32px;
}


}
`, "",{"version":3,"sources":["webpack://./src/components/profile/profile.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;IACjB,aAAa;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;;cAEY;EACZ,iBAAiB;EACjB,aAAa;EACb,wDAAwD,EAAE,2CAA2C;EACrG,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;IACd,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;;AAGA,2BAA2B;AAC3B;EACE;IACE,aAAa;IACb,2BAA2B;IAC3B,MAAM;EACR;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;;EAGA;IACE,WAAW;IACX,YAAY;EACd;;;EAGA;IACE,YAAY;AAChB;;EAEE;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;;EAGA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,8BAA8B;EAChC;;EAEA;EACA,WAAW;EACX,YAAY;AACd;AACA;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sDAAsD,EAAE,2CAA2C;IACnG,SAAS;EACX;;;;EAIA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE;EACF;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;EACA,WAAW;EACX,YAAY;AACd;;;AAGA","sourcesContent":[".profile-main-wrapper {\r\n  /* margin-top: 46px; */\r\n  margin-top: 21px;\r\n}\r\n\r\n.profile-heading-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.profile-heading-wrap img {\r\n  width: 32px;\r\n  height: 32px;\r\n  cursor: pointer;\r\n}\r\n\r\n.profile-heading-wrap img:hover{\r\n  scale: 0.9;\r\n}\r\n\r\n.profile-readonly-info-wrap {\r\n  margin-top: 40px;\r\n}\r\n\r\n.profile-readonly-info-repeat {\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.profile-readonly-info-repeat p {\r\n  font-size: 12px;\r\n  color: #626262;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  opacity: 0.5;\r\n  padding-bottom: 14px;\r\n}\r\n\r\n.profile-readonly-info-repeat span {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 500;\r\n  margin: 0px;\r\n}\r\n\r\n.profile-detail-main-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.pofile-detail-main-wrap h3 {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n  padding-bottom: 2px;\r\n}\r\n\r\n.pofile-detail-main-wrap p {\r\n  font-size: 14px;\r\n  color: #1A1919;\r\n  font-weight: 500;\r\n  margin: 0px;\r\n}\r\n\r\n.profile-main-wrap {\r\n  display: grid;\r\n  grid-template-columns: 100%;\r\n  gap: 25px;\r\n  align-items: center;\r\n}\r\n\r\n.profile-left-wrap h2 {\r\n  font-size: 38px;\r\n  color: #14172e;\r\n  font-weight: bold;\r\n  margin: 0px;\r\n}\r\n\r\n.profile-picture-wrap {\r\n  position: relative;\r\n  margin-top: -58px;\r\n  width: 150px;\r\n}\r\n\r\n.profile-page-main-image {\r\n  width: 100%;\r\n}\r\n\r\n.profile-page-main-image img {\r\n  width: 100%;\r\n  /* height: 210px; */\r\n  border-radius: 17px;\r\n    height: 192px;\r\n  object-fit: fill;\r\n}\r\n\r\n.profile-picture-wrap img {\r\n  width: 140px;\r\n  height: 140px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.profile-edit-icon img {\r\n  position: absolute;\r\n  bottom: 28px;\r\n  right: 0px;\r\n  width: 40px;\r\n  height: 40px;\r\n  cursor: pointer;\r\n  object-fit: cover;\r\n}\r\n\r\n.upload-profileImage-gif {\r\n  position: absolute;\r\n  bottom: 28px;\r\n  right: 0px;\r\n  width: 40px;\r\n  height: 40px;\r\n  background: #00a19b;\r\n  border-radius: 50%;\r\n}\r\n\r\n.profile-info-main-wrapper {\r\n  /* display: flex;\r\n  justify-content: space-between;\r\n  gap: 50px; */\r\n  /* width: 100%; */\r\n  display: grid;\r\n  grid-template-columns: calc(74% - 18px) calc(26% - 18px); /* Adjust for half the gap on each column */\r\n  gap: 36px;\r\n}\r\n\r\n.profile-basic-info-wrap {\r\n  position: relative;\r\n  margin-top: 16px;\r\n  width: 100%;\r\n  /* height: 406px; */\r\n  height: 416px;\r\n  border: 2px solid #f8f8f8;\r\n  /* border: 2px solid #cac8c994; */\r\n  padding: 0px 54px;\r\n  /* padding-top: 56px; */\r\n  padding-top: 32px;\r\n  border-radius: 34px;\r\n}\r\n\r\n.profile-detail-icon img {\r\n  width: 70px;\r\n  height: 70px;\r\n  position: absolute;\r\n  top: 20px;\r\n  right: 20px;\r\n  object-fit: cover;\r\n}\r\n\r\n.profile-basic-info-wrap h4 {\r\n  font-size: 18px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n  /* margin-bottom: 40px; */\r\n}\r\n\r\n.profile-info-header-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  /* margin-bottom: 40px; */\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.profile-left-inner-wrapper{\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 70px;\r\n  padding: 0px 34px\r\n}\r\n\r\n.profile-left-inner-wrapper .profile-inner-basic-info{\r\n  width: 50%;\r\n}\r\n\r\n.profile-left-inner-wrapper .change-password-info-wrap{\r\n  width: 50%;\r\n}\r\n\r\n.profile-info-header-wrapper button{\r\n  width: 114px;\r\n  height: 49px;\r\n}\r\n\r\n.profile-info-heading-wrap{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.profile-info-heading-wrap img{\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.profile-right-image-wrap {\r\n  width: 88%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.profile-right-image-wrap img {\r\n  width: 100%;\r\n  object-fit: cover;\r\n  border-radius: 18px;\r\n}\r\n\r\n.change-input-wrap img {\r\n  width: 22px;\r\n  height: 22px;\r\n  position: absolute;\r\n  top: 0px;\r\n  cursor: pointer;\r\n}\r\n\r\n.twofa-enable-main-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  border: 1px solid #f3f3f3;\r\n  border-radius: 9px;\r\n  padding: 0px 18px;\r\n  height: 62px;\r\n}\r\n\r\n.twofa-enable-left-wrap p {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 500;\r\n  margin: 0px;\r\n}\r\n\r\n.profile-changes-button {\r\n  /* width: 30%; */\r\n    width: 42%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.profile-changes-button button {\r\n  width: 219px;\r\n  height: 49px;\r\n  font-size: 14px;\r\n}\r\n\r\n.twofa-desable-req-main-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  border: 1px solid #f3f3f3;\r\n  background: #f3f3f3;\r\n  border-radius: 9px;\r\n  padding: 0px 18px;\r\n  height: 62px;\r\n}\r\n\r\n.twofa-desable-req-main-wrap img {\r\n  width: 34px;\r\n}\r\n\r\np.resend-email-text {\r\n  font-size: 12px;\r\n  color: #00a19b;\r\n  font-weight: 500;\r\n  margin: 0px;\r\n  padding-top: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\nspan.error-msg.profile-error-msg {\r\n  position: absolute;\r\n  bottom: -16px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.profile-guideline-info-wrap img{\r\n  width: 16px;\r\n  height: 16px;\r\n  position: absolute;\r\n  left: 9px;\r\n  top: 110px;\r\n  cursor: pointer;\r\n}\r\n\r\n.profile-left-inner-wrapper .field {\r\n  margin-bottom: 36px;\r\n}\r\n\r\n.profile-info-heading-wrap img.info-icon{\r\n  width: unset;\r\n  height: unset;\r\n  position: absolute;\r\n  right: -10px;\r\n  top: -2px;\r\n  cursor: pointer;\r\n}\r\n\r\n.profile-readonly-info-wrap1{\r\n  margin-top: 32px;\r\n}\r\n\r\n.profile-twofa-security-img-wrap{\r\n  position: relative;\r\n}\r\n\r\n.phone-number-input-box {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.number-flag-box-wrap {\r\n  width: 74px;\r\n  height: 62px;\r\n  border: 1px solid;\r\n  border: 1px solid #f3f3f3;\r\n  border-radius: 9px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n}\r\n\r\n.number-flag-box-wrap img{\r\n  width: 22px;\r\n}\r\n\r\n.number-flag-box-wrap p{\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #1A1919;\r\n  margin: 0px;\r\n}\r\n\r\n.phone-number-input-box{\r\n  position: relative;\r\n}\r\n\r\n\r\n/******* Resposive css ****/\r\n@media (max-width: 1024px) {\r\n  .profile-main-wrap {\r\n    display: grid;\r\n    grid-template-columns: 100%;\r\n    gap: 0;\r\n  }\r\n\r\n  .profile-info-main-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 18px;\r\n    padding-bottom: 40px;\r\n  }\r\n\r\n  .profile-right-wrap {\r\n    display: none;\r\n  }\r\n\r\n  .profile-left-wrap h2 {\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .profile-picture-wrap img {\r\n    width: 120px;\r\n    height: 120px;\r\n  }\r\n\r\n\r\n  .profile-guideline-info-wrap img{\r\n    width: 16px;\r\n    height: 16px;\r\n  }\r\n\r\n  \r\n  .profile-picture-wrap {\r\n    width: 120px;\r\n}\r\n\r\n  .profile-edit-icon img {\r\n    width: 34px;\r\n    height: 34px;\r\n    bottom: 25px;\r\n    right: 0px;\r\n  }\r\n\r\n  .profile-guideline-info-wrap img {\r\n    left: 9px;\r\n    top: 100px;\r\n  }\r\n\r\n  .upload-profileImage-gif {\r\n    bottom: 30px;\r\n    right: 0px;\r\n    width: 42px;\r\n    height: 42px;\r\n  }\r\n\r\n  .profile-basic-info-wrap {\r\n    margin-top: 0px;\r\n    height: auto;\r\n    padding: 43px 18px;\r\n    padding-bottom: 23px;\r\n  }\r\n\r\n  .profile-basic-info-wrap h4 {\r\n    font-size: 18px;\r\n    margin-bottom: 0px;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .profile-input-field {\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n  .profile-main-wrapper {\r\n    padding-bottom: 100px;\r\n  }\r\n\r\n  .profile-readonly-info-repeat p {\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .login-button.profile-changes-button {\r\n    position: fixed;\r\n    width: 100%;\r\n    padding-right: 40px !important;\r\n    padding-left: 0px !important;\r\n    background-color: #fff;\r\n    z-index: 99;\r\n    bottom: 90px;\r\n  }\r\n\r\n  .profile-picture-main-wrap {\r\n    width: 50%;\r\n    margin: unset;\r\n  }\r\n\r\n  .change-password-info-wrap {\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .profile-changes-button {\r\n    width: 100%;\r\n  }\r\n\r\n  .profile-readonly-info-wrap {\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .profile-page-main-image img {\r\n    width: 100%;\r\n    height: 150px;\r\n    object-fit: cover;\r\n    border-radius: 10px;\r\n  }\r\n\r\n\r\n  .profile-detail-main-wrapper {\r\n    gap: 10px;\r\n  }\r\n\r\n  .profile-info-header-wrapper {\r\n    margin-bottom: 34px;\r\n  }\r\n\r\n  .profile-readonly-info-repeat {\r\n    margin-top: 35px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .profile-detail-icon img {\r\n    width: 55px;\r\n    height: 55px;\r\n  }\r\n\r\n  .twofa-enable-main-wrapper {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .profile-left-inner-wrapper {\r\n    display: block;\r\n    padding: 0px 0px;\r\n  }\r\n\r\n  .profile-left-inner-wrapper .profile-inner-basic-info {\r\n    width: 100%;\r\n  }\r\n\r\n  .profile-left-inner-wrapper .change-password-info-wrap {\r\n    width: 100%;\r\n  }\r\n\r\n  .profile-left-inner-wrapper .field {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .profile-changes-button button {\r\n    width: 100%;\r\n    height: 49px;\r\n  }\r\n\r\n  .profile-info-heading-wrap img{\r\n    width: 35px;\r\n    height: 35px;\r\n  }\r\n}\r\n\r\n@media (max-width: 450px) {\r\n.pofile-detail-main-wrap p {\r\n  width: 200px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .pofile-detail-main-wrap h3 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .pofile-detail-main-wrap p {\r\n    font-size: 12px;\r\n    width: 120px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n  .login-button.profile-changes-button {\r\n    position: fixed;\r\n    width: 100%;\r\n    padding-right: 20px !important;\r\n  }\r\n\r\n  .profile-info-heading-wrap img{\r\n  width: 34px;\r\n  height: 34px;\r\n}\r\n}\r\n\r\n@media (min-width: 1025px) and (max-width: 1599px) {\r\n  span.error-msg.profile-error-msg {\r\n    position: absolute;\r\n    bottom: -6px;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .profile-left-wrap h2 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .profile-picture-wrap {\r\n    position: relative;\r\n    margin-top: -54px;\r\n    width: 120px;\r\n  }\r\n\r\n  .profile-guideline-info-wrap img {\r\n    left: -1px;\r\n    top: 80px;\r\n  }\r\n\r\n  .profile-picture-wrap img {\r\n    width: 108px;\r\n    height: 108px;\r\n  }\r\n\r\n  .profile-guideline-info-wrap img{\r\n    width: 16px;\r\n    height: 16px;\r\n  }\r\n\r\n  .profile-page-main-image img {\r\n    width: 100%;\r\n    height: 130px;\r\n    object-fit: fill;\r\n  }\r\n\r\n  .profile-guideline-info-wrap img{\r\n    width: 16px;\r\n    height: 16px;\r\n  }\r\n\r\n  .profile-edit-icon img {\r\n    width: 30px;\r\n    height: 30px;\r\n    bottom: 30px;\r\n    right: 6px;\r\n  }\r\n\r\n  .upload-profileImage-gif {\r\n    width: 32px;\r\n    height: 32px;\r\n    bottom: 40px;\r\n    right: 60px;\r\n  }\r\n\r\n  .profile-heading-wrap {\r\n    gap: 12px;\r\n  }\r\n\r\n  .profile-heading-wrap img {\r\n    width: 21px;\r\n    height: 21px;\r\n  }\r\n\r\n  .profile-basic-info-wrap {\r\n    margin-top: 0px;\r\n    height: 282px;\r\n    border-radius: 24px;\r\n    padding: 0px 30px\r\n  }\r\n\r\n  .profile-readonly-info-wrap {\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .profile-detail-icon img {\r\n    width: 52px;\r\n    height: 52px;\r\n    top: 10px;\r\n    right: 10px;\r\n  }\r\n\r\n  .profile-info-header-wrapper {\r\n    margin-bottom: 14px;\r\n    margin-top: 14px;\r\n  }\r\n\r\n  .profile-readonly-info-wrap .profile-info-header-wrapper {\r\n    margin-bottom: 34px;\r\n  }\r\n\r\n  .twofa-enable-main-wrap {\r\n    height: 48px;\r\n  }\r\n\r\n  .profile-basic-info-wrap h4 {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    line-height: normal;\r\n  }\r\n\r\n  .profile-readonly-info-repeat p {\r\n    padding-bottom: 8px;\r\n  }\r\n\r\n  .profile-readonly-info-repeat {\r\n    margin-bottom: 36px;\r\n  }\r\n\r\n  .profile-readonly-info-repeat span {\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .profile-main-wrap {\r\n    grid-template-columns: 100%;\r\n    gap: 20px;\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .twofa-enable-left-wrap p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  p.disable-req-text {\r\n    font-weight: 400;\r\n  }\r\n\r\n  .twofa-desable-req-main-wrap img {\r\n    width: 26px;\r\n  }\r\n\r\n  .profile-right-image-wrap {\r\n    width: 400px;\r\n    height: 535px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .profile-right-image-wrap img {\r\n    width: 100%;\r\n    height: 535px;\r\n    object-fit: cover;\r\n  }\r\n\r\n  .profile-basic-info-wrap button {\r\n    height: 48px;\r\n  }\r\n\r\n  .profile-info-main-wrapper {\r\n    grid-template-columns: calc(74% - 9px) calc(26% - 9px); /* Adjust for half the gap on each column */\r\n    gap: 18px;\r\n  }\r\n\r\n\r\n\r\n  .profile-picture-main-wrap {\r\n    margin-top: 12px;\r\n  }\r\n\r\n  .profile-main-wrapper {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  p.resend-email-text {\r\n    padding-top: 7px;\r\n  }\r\n\r\n  .twofa-desable-req-main-wrap {\r\n    height: 48px;\r\n  }\r\n\r\n  .twofa-confirm-modal-content-wrap p {\r\n    width: 90%;\r\n  }\r\n\r\n  .profile-left-inner-wrapper .field {\r\n    margin-bottom: 18px;\r\n  }\r\n\r\n  .pofile-detail-main-wrap h3 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .pofile-detail-main-wrap p {\r\n    font-size: 12px;\r\n    color: #1A1919;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .profile-detail-main-wrapper {\r\n    gap: 10px;\r\n  }\r\n\r\n  .profile-left-inner-wrapper {\r\n    gap: 50px\r\n  }\r\n\r\n  .number-flag-box-wrap {\r\n    width: 74px;\r\n    height: 48px;\r\n  }\r\n\r\n  .number-flag-box-wrap img {\r\n    width: 20px;\r\n  }\r\n\r\n  .number-flag-box-wrap p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .profile-info-heading-wrap img{\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
